module.exports = __webpack_public_path__ + "img/button_diameter.a8dc17dc.png";